import { render } from "./wokerDetail9.vue?vue&type=template&id=2a2e75cd&scoped=true"
import script from "./wokerDetail9.vue?vue&type=script&lang=js"
export * from "./wokerDetail9.vue?vue&type=script&lang=js"

import "./wokerDetail9.vue?vue&type=style&index=0&id=2a2e75cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2e75cd"]])

export default __exports__